<template>
    <div>
        <h2 v-if="this.title">{{ $t("dashboard.text_16") }}</h2>
        <div id="main"></div>
    </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    props: ["data", "title"],
    data() {
        return {
            all_months: [
                this.$t("statistics.january"),
                this.$t("statistics.february"),
                this.$t("statistics.march"),
                this.$t("statistics.april"),
                this.$t("statistics.may"),
                this.$t("statistics.june"),
                this.$t("statistics.july"),
                this.$t("statistics.august"),
                this.$t("statistics.september"),
                this.$t("statistics.october"),
                this.$t("statistics.november"),
                this.$t("statistics.december"),
            ],
            myChart: null,
        };
    },
    mounted() {
        this.setChart();
        setTimeout(() => {
            if (this.myChart) {
                this.myChart.resize();
            }
        }, 2000);
    },
    methods: {
        setChart() {
            this.myChart = echarts.init(document.getElementById("main"));
            var options = {
                grid: {
                    top: "20px",
                    left: "20px",
                    right: "40px",
                    bottom: "20px",
                    containLabel: true,
                },
                backgroundColor: "#fff",
                tooltip: {
                    trigger: "item",
                    formatter: function (params) {
                        return this.formatPrice(params.value) + " " + this.$currency.symbol;
                    }.bind(this),
                    backgroundColor: "rgba(54, 58, 83, 0.88)",
                    textStyle: {
                        color: "#fff",
                    },
                    borderColor: "rgba(54, 58, 83, 0.88)",
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.labels(),
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#9CA3AF",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        // formatter: function (params) {
                        //     return params.split("/")[0];
                        // }.bind(this),
                        padding: [10, 10, 10, 10],
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#9CA3AF",
                        },
                    },
                    axisLabel: {
                        formatter: function (params) {
                            return this.formatPrice(params) + " " + this.$currency.symbol;
                        }.bind(this),
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                },
                series: [
                    {
                        data: this.data,
                        type: "line",
                        symbolSize: 7,
                        symbol: "circle",
                        lineStyle: {
                            width: 5,
                            color: "#F93C34",
                        },
                        itemStyle: {
                            borderWidth: 2,
                            borderColor: "#F93C34",
                            color: "#fff",
                        },
                        areaStyle: {
                            opacity: 0.6, // This sets the overall opacity of the areaStyle
                            color: new echarts.graphic.LinearGradient(
                                0, // x start position
                                0, // y start position
                                0, // x end position (0 means vertical gradient)
                                1, // y end position (1 means the gradient extends to the end of the chart area)
                                [
                                    { offset: 0, color: "#F93C34" }, // start color
                                    {
                                        offset: 1,
                                        color: "rgba(249, 60, 52, 0)",
                                    }, // end color with transparency
                                ]
                            ),
                        },
                    },
                ],
            };
            this.myChart.setOption(options);
            window.addEventListener("resize", this.myChart.resize);
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        labels() {
            var labels = [];
            var today = new Date();
            for (var i = 5; i >= 0; i -= 1) {
                var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
                labels.push(
                    (d.getMonth() + 1).toString() +
                        "/" +
                        d.getFullYear().toString()
                );
            }
            return labels;
        },
    },
};
</script>

<style lang="scss" scoped>
h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #212541;
}
#main {
    width: 100%;
    height: 420px;
    @media (max-width: 1600px) {
        height: 350px;
    }
    @media (max-width: 1400px) {
        height: 320px;
    }
    @media (max-width: 1200px) {
        height: 300px;
    }
}
</style>
